import { Component } from "react";
import { GetQuery, langCheck } from "Pub/js/utils";
import { connect } from "react-redux";
import { getMultiLangValue, getCurrentLangText, getLanguageMetas } from "Pub/js/getMulti";
import DragModal from "Pages/NewHome/AppGroup/DragModal";
import { withRouter } from "react-router-dom";
import DragDropItem from "Components/DragDropItem";
import { getRelateidObj, defaultCardArrangement, getAppTabArr } from "Pages/NewHome/utilService";
import platform from "Pub/js/platform";
const { toast } = platform;
const { NCSidebox, NCMultiLangText, NCRadio, NCInputNumber, NCPopconfirm } = platform.base;
const { NCRadioGroup } = NCRadio;
import { cloneDeep } from "lodash";
// import WidgetSideDom from '../../../../../../business_component/widgetSide/publicSetting/main/index'
import WidgetJSLoader from "Pages/NewHome/CreaterForWidget/WidgetJSLoader";
import { WidgetSidePath } from "Pub/js/constant";
import './index.less';

class AppGroupSide extends Component {
    constructor(props) {
        super(props);
        const urlParams = GetQuery(window.location.hash);
        const { sideData = {} } = props;
        const { cardList = [], cardArrangement = defaultCardArrangement } = sideData;
        const defaultSideData = { // 默认值
            cardArrangement,
            cardList,
            appTab: getAppTabArr(sideData),
        }
        this.languageMetas = getLanguageMetas();
        this.state = {
            appGroupSideData: defaultSideData,
            relateidObj: getRelateidObj(
                urlParams.pk_responsibility,
                urlParams.is_group,
                urlParams.workbenchid
            ),
            widgetSide: null
        }
    }
    componentDidMount() {
        // 获取侧拉弹框公众数据
        WidgetJSLoader(WidgetSidePath, key => {
            const widgetSide = window[key].default;
            if (widgetSide) {
                this.setState({
                    widgetSide
                });
            }
        });
    }
    componentWillReceiveProps(nextProps) {
        const { sideData: sideDataNext } = nextProps;
        const { cardList: cardListNext, } = sideDataNext;
        const { appGroupSideData } = this.state;
        const newAppGroupSideData = { ...appGroupSideData, cardList: cardListNext, appTab: getAppTabArr(sideDataNext) };
        if (!_.isEqual(appGroupSideData, newAppGroupSideData)) {
            this.setState({
                appGroupSideData: newAppGroupSideData
            })
        }
    }
    // // 获取名称多语值
    // getNameValue() {
    //     const { appGroupSideData } = this.state;
    //     return getMultiLangValue('name', appGroupSideData);
    // }

    // 数据改变
    handleChange(value, key) {
        const { appGroupSideData } = this.state;
        appGroupSideData[key] = value;
        this.setState(appGroupSideData);
        this.onChangeProps(appGroupSideData);

    }

    // 弹窗新增卡片回调
    updateApps(dataList) {
        const { appGroupSideData } = this.state;
        const updatedData = {
            ...appGroupSideData,
            cardList: dataList
        }
        this.setState({
            appGroupSideData: updatedData
        })
        this.onChangeProps(updatedData);
    }

    // 删除卡片
    deleteCard(index) {
        const { appGroupSideData } = this.state;
        const updatedData = { ...appGroupSideData };
        updatedData.cardList.splice(index, 1);
        this.setState({
            appGroupSideData: updatedData
        })
        this.onChangeProps(updatedData);
        // toast({ content: langCheck('0000PUB-000406' /* 删除成功 */) });
    }

    // 应用列表 处理拖拽排序
    cardHandleDragDropChange({ dragItem, dropItem }) {
        const { appGroupSideData } = this.state;
        const updatedData = { ...appGroupSideData };
        const { cardList } = updatedData;
        const dragIndex = dragItem.index;
        const dropIndex = dropItem.index;
        const dragedItem = cardList.splice(dragIndex, 1)[0];
        cardList.splice(dropIndex, 0, dragedItem);
        this.setState({
            appGroupSideData: updatedData
        })
        this.onChangeProps(updatedData);
    }
    // 应用页签 处理拖拽排序
    handleDragDropChange({ dragItem, dropItem }) {
        const { appGroupSideData } = this.state;
        const updatedData = { ...appGroupSideData };
        const { appTab } = updatedData;
        const dragIndex = dragItem.index;
        const dropIndex = dropItem.index;
        const dragedItem = appTab.splice(dragIndex, 1)[0];
        appTab.splice(dropIndex, 0, dragedItem);
        this.setState({
            appGroupSideData: updatedData
        })
        this.onChangeProps(updatedData);

    }
    // 设置页签显隐
    setAppTab = (data) => {
        const { key, show } = data;
        const { appGroupSideData } = this.state;
        const updatedData = cloneDeep(appGroupSideData);
        const { appTab } = updatedData;
        const hasData = appTab.filter((item) => item.show);
        if (hasData && hasData.length === 1) {
            appTab.forEach((item) => {
                if (item.key === key) {
                    item.show = !show;
                    item.select = !show;
                } else {
                    item.show = true;
                    item.select = true;
                }
            })
        } else if (hasData && hasData.length === 2) {
            appTab.forEach((item) => {
                if (item.key === key) {
                    item.show = !show;
                    item.select = !show;
                } else {
                    item.select = show;
                }
            })
        }

        this.setState({
            appGroupSideData: updatedData
        })
        this.onChangeProps(updatedData);
    }
    onChangeProps = (updatedData) => {
        const { onChange, sideData } = this.props;
        const { publicData } = sideData;
        onChange({ ...updatedData, publicData });

    }
    // 添加应用
    addApp = () => {
        this.setState({
            dragModalShow: true
        })
    }
    // 应用页签
    renderAppTab = () => {
        const { appGroupSideData, } = this.state;
        const { appTab, } = appGroupSideData;
        return <div className="side-item">
            <span
                className="item-label item-label-normal"
            >
                {langCheck('0000PUB-000562') /** 应用页签 */}
                <span>{langCheck('0000PUB-000563') /** 至少展示一个页签 */}</span>
            </span>
            <div className="item-content card-list">
                {
                    appTab.map((card, index) => {
                        const { bgcolor = 'transparent', icon = '', show } = card;
                        return <DragDropItem
                            item={{ ...card, index }}
                            onDragDropChange={this.handleDragDropChange.bind(this)}
                        >
                            <div className="card-item">
                                <i className="iconfont icon-tuozhuai1 icon-drag"></i>
                                <div className={`card-item-main ${!show ? 'hide' : ''}`}>
                                    <span className="title">{getCurrentLangText('title', card)}</span>
                                </div>
                                <div className="operation"
                                    onClick={this.setAppTab.bind(this, card)}
                                >
                                    {
                                        show ? <i className="iconfont icon-icon-xianshi2 opr-icon"></i> : <i className="iconfont icon-icon-yincang2 opr-icon"></i>
                                    }
                                </div>
                            </div>
                        </DragDropItem>
                    })
                }
            </div>
        </div>
    }
    // 应用列表
    renderAppList = () => {
        const { appGroupSideData, } = this.state;
        const { cardList, } = appGroupSideData;
        const { saveExternalLinkData } = this.props;
        return <div className="side-item">
            <span className="item-label">
                {langCheck('0000PUB-000560' /* 应用列表 */)}
                <div className="card-add" onClick={() => { this.addApp() }}>
                    <i className="iconfont icon-ncc-sq"></i>
                    <span>{langCheck('0000PUB-000561' /* 添加应用 */)}</span>
                </div>
            </span>
            {
                cardList && cardList.length
                    ?
                    <div className={`item-content card-list`}>
                        {
                            cardList.map((card, index) => {
                                const { bgcolor = 'transparent', icon = '', name, cardid } = card;
                                const title = saveExternalLinkData[cardid] && saveExternalLinkData[cardid].name || name;
                                return <DragDropItem
                                    item={{ ...card, index }}
                                    onDragDropChange={this.cardHandleDragDropChange.bind(this)}
                                >
                                    <div className="card-item">
                                        <i className="iconfont icon-tuozhuai1 icon-drag"></i>
                                        <div className="card-item-main">
                                            <span className="title">{title}</span>
                                        </div>
                                        <div className="operation">
                                            {/* <NCPopconfirm
                                                trigger="click"
                                                placement="left"
                                                content={langCheck('0000PUB-000006'  确定要删除吗? /)}
                                                onClose={() => { this.deleteCard(index) }}
                                            > */}
                                            <i
                                                className="iconfont icon-shanchu5 opr-icon"
                                                onClick={() => { this.deleteCard(index) }}
                                            ></i>
                                            {/* </NCPopconfirm> */}
                                        </div>
                                    </div>
                                </DragDropItem>
                            })
                        }
                    </div>
                    :
                    null
            }
        </div>
    }
    // 排列方式
    renderArrangement = () => {
        const { appGroupSideData } = this.state;
        const { cardArrangement } = appGroupSideData;
        return <div className="side-item">
            <span className="item-label">{langCheck('0000PUB-000564') /** 排列方式  */}</span>
            <div className="item-content">
                <NCRadioGroup
                    className='radio-group-name'
                    selectedValue={cardArrangement}
                    name='cardArrangement'
                    onChange={(val) => {
                        this.handleChange(val, 'cardArrangement')
                    }}
                >
                    <NCRadio value='upDown'>{langCheck('0000PUB-000558' /* 上下排列 */)}</NCRadio>
                    <NCRadio value='around'>{langCheck('0000PUB-000559' /* 左右排列 */)}</NCRadio>
                </NCRadioGroup>
            </div>
        </div>
    }
    render() {
        const { onClose, } = this.props;
        const { appGroupSideData, dragModalShow, widgetSide: WidgetSide } = this.state;
        const { cardList, appTab } = appGroupSideData;
        let title = '';
        if (appTab && appTab.length) {
            title = getCurrentLangText('title', appTab.filter((item) => item.key === 'app')[0]);
        }
        return typeof WidgetSide === 'function'
            ? <WidgetSide
                maskClose={onClose}
                onClose={onClose}
                widgetProps={this.props}
                hideArea={['switch']}
            >
                <div className="common-widget-side app-group-side">
                    {this.renderAppTab()}
                    {this.renderAppList()}
                    {this.renderArrangement()}
                    {
                        dragModalShow && <DragModal
                            defaultData={cardList}
                            onOk={this.updateApps.bind(this)}
                            onCancel={() => {
                                this.setState({
                                    dragModalShow: false
                                })
                            }}
                            title={title}
                        />
                    }
                </div>
            </WidgetSide>
            : null
    }
}


AppGroupSide = connect(
    state => ({
        saveExternalLinkData: state.gridLayoutData.saveExternalLinkData
    }),
    {
    }
)(AppGroupSide);
export default withRouter(AppGroupSide);